import { render, staticRenderFns } from "./bodyInfo.vue?vue&type=template&id=f43a4bee&scoped=true&"
import script from "./bodyInfo.vue?vue&type=script&lang=js&"
export * from "./bodyInfo.vue?vue&type=script&lang=js&"
import style0 from "./bodyInfo.vue?vue&type=style&index=0&id=f43a4bee&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f43a4bee",
  null
  
)

export default component.exports